import { gql } from '@apollo/client';

export const GET_CHILDREN = gql`
  query getMyProfile {
    profileNewModel {
      children {
        institutionGradeLevel
        status
      }
    }
  }
`;
